import React from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import TemplateLibrary from '../components/TemplateLibrary';

const Templates = () => {
  const navigate = useNavigate();

  const handleSelectTemplate = (template) => {
    // Navigate to the resume builder with the selected template
    if (template?.id) {
      navigate(`/builder/${template.id}`);
    } else {
      navigate('/resume-builder');
    }
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      <main className="py-8">
        <TemplateLibrary onSelectTemplate={handleSelectTemplate} />
      </main>
      <Footer />
    </div>
  );
};

export default Templates;
